import { Flex, Text, MuiDatePicker } from '@pinchenterprisesnpm/friday-ui'
import { FormikProps } from 'formik'
import { CustomValidationError } from '@src/features/shift-post-v2/style'
import { INewEditModalFormValues } from '../../new-edit-modal.form'

const { DatePickerSingle } = MuiDatePicker

interface ISingleDayPickerProps {
  formik: FormikProps<INewEditModalFormValues>
}

export const SingleDayPicker = ({ formik }: ISingleDayPickerProps) => {
  const { values, setFieldValue, errors } = formik

  return (
    <Flex flexDirection='column'>
      <Text mt={0} mb='xs'>
        Select Date
      </Text>

      <DatePickerSingle
        selectedDay={values.single_day_date}
        onDayClick={(day) => {
          setFieldValue('single_day_date', day)
        }}
        onReset={() => setFieldValue('single_day_date', undefined)}
      />

      {errors.single_day_date && typeof errors.single_day_date === 'string' ? (
        <CustomValidationError mt='xs' mb={0}>
          {errors.single_day_date}
        </CustomValidationError>
      ) : null}
    </Flex>
  )
}
